import React from 'react';
import { BadgeCheckIcon, FileCheck2Icon, GiftIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-[#101a12] px-5 py-20" data-id="element-84" data-mp="4xcmcz56cod4">
      <div className="mx-auto max-w-3xl border-t-8 border-emerald-400 bg-white p-8 text-center shadow-2xl sm:p-14" data-id="element-85" data-mp="9tbemxtmiqit">
        <p className="inline-flex items-center gap-2 bg-emerald-500 px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-86" data-mp="eu8ydeua7smf">
          <BadgeCheckIcon className="h-4 w-4" data-id="element-87" data-mp="jqpscpo5x17f" />
          Zero rischi · 100% protetto
        </p>
        <ShieldCheckIcon className="mx-auto mt-7 h-20 w-20 text-emerald-700" strokeWidth={1.4} data-id="element-88" data-mp="nrrlcorhkh0y" />
        <h2 className="mt-6 font-display text-5xl font-bold uppercase leading-none text-[#102016] sm:text-6xl" data-id="element-89" data-mp="xkgtb9ntvcrj">
          Garanzia di <span className="text-emerald-700" data-id="element-90" data-mp="12k35rgvu0oza">7 giorni</span>
        </h2>
        <p className="mx-auto mt-6 max-w-lg text-lg font-medium text-slate-600" data-id="element-91" data-mp="17hv711id9ng5">
          Apri tutto. Usa il materiale nelle tue lezioni di Tennis.
        </p>
        <p className="mt-5 text-2xl font-bold leading-tight text-[#102016]" data-id="element-92" data-mp="25pu9bbirnmh2">
          Se Tennis Pronto non trasforma il modo in cui pianifichi e gestisci il
          tuo Club,{' '}
          <span className="text-emerald-700" data-id="element-93" data-mp="1vu9bzqon7adn">
            ti rimborseremo ogni centesimo — senza domande.
          </span>
        </p>
        <p className="mt-4 text-sm font-medium text-slate-600" data-id="element-94" data-mp="2oiezgl72zdh6">
          I bonus restano tuoi come ringraziamento per averci provato.
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-3 text-xs font-bold text-[#102016]" data-id="element-95" data-mp="2jkd8le3ey9v5">
          <span className="flex items-center gap-1.5" data-id="element-96" data-mp="2er277shdelam">
            <ZapIcon className="h-4 w-4 text-emerald-700" data-id="element-97" data-mp="2ar9ynfrz8f59" />
            Rimborso semplice
          </span>
          <span className="flex items-center gap-1.5" data-id="element-98" data-mp="379fxn70dn4zo">
            <FileCheck2Icon className="h-4 w-4 text-emerald-700" data-id="element-99" data-mp="37b0qms71mfvf" />
            Nessun modulo da compilare
          </span>
          <span className="flex items-center gap-1.5" data-id="element-100" data-mp="10knmhzaqm8mx">
            <GiftIcon className="h-4 w-4 text-emerald-700" data-id="element-101" data-mp="10l5tnqyxu79m" />I bonus restano
            tuoi
          </span>
        </div>
        <p className="mt-6 inline-block border border-emerald-500/40 bg-emerald-50 px-4 py-2 text-xs font-bold uppercase tracking-widest text-emerald-800" data-id="element-102" data-mp="15ltfzzc81zxi">
          Garanzia soddisfatti o rimborsati
        </p>
      </div>
    </section>;
}